import { ArrowDown16, ArrowRight16 } from '@makyoapp/makyo-icon/icon'

import { FunctionDirection } from './types'

export const DEFAULT_FAVORITE_FUNCTIONS = [
  'sum',
  'index',
  'average',
  'if',
  'vlookup',
  'countifs',
  'concat',
  'max',
  'min',
  'date',
  'index',
  'match',
  'and',
  'or',
  'product',
  'round',
  'is-blank',
  'is-number',
  'len',
  'substitute',
  'today',
]

export const FUNCTION_DIRECTION_OPTIONS = [
  {
    id: FunctionDirection.Vertical,
    title: 'Vertical',
    icon: <ArrowDown16 />,
  },
  {
    id: FunctionDirection.Horizontal,
    title: 'Horizontal',
    icon: <ArrowRight16 />,
  },
]
